import './SectionCardStyle.less';

import { Icon } from '@opendoor/bricks';
import * as React from 'react';

export interface ISectionCardProps {
  className?: string;
  headerText: string;
  id?: string;
}

export default class SectionCard extends React.PureComponent<ISectionCardProps> {
  public static defaultProps: Partial<ISectionCardProps> = {
    className: '',
    id: '',
  };

  public render() {
    const { children, className, headerText, id } = this.props;

    return (
      <div className={`section-card ${className}`} id={id}>
        <div className="section-card-header">
          <Icon className="section-card-header-icon" name="arrow-right-square" />
          {headerText}
        </div>
        {children}
      </div>
    );
  }
}
